<template>
    <CommonDialog :value="value" :fullscreen="true" :title="$t('Permissions')" show-action-toolbar @input="$emit('input', false)">
        <v-card-text>
            <v-row>
                <v-col v-for="permission in userPermissionsList" :key="permission.id" cols="12" md="12">
                    <v-card tile color="grey lighten-4">
                        <v-toolbar desnse color="primary" class="white--text" height="35px">
                            {{ $t(permission.typeName) }}
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" v-for="group in permission.items" :key="group">
                                    <v-card tile>
                                        <div class="card-title"> {{ $t(group.groupName)}}</div>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="4" v-for="item in group.items" :key="item.id">
                                                    <v-checkbox v-model="item.hasAccess" :label="$t(item.name)" class="text-start" color="teal" hide-details @change="updatePermission($event, item.id, permission.id)" />
                                                    <v-radio-group v-model="item.levelId" v-if="item.hasLevel">
                                                        <v-radio dense  v-for="permission in permissionLevels" color="secondary" :key="permission.id" :label="$t(permission.name)" :value="permission.id" @change="setLevel(item,permission.id)"></v-radio>
                                                    </v-radio-group>

                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <!-- Initiate procedures: the per-user CaseProcess grant (PermissionMatrix RecordId = ProcessType.Id).
                     Menu items are the checkboxes above; task handling comes from the user's role in the structure. -->
                <v-col v-if="processPermissions.length" cols="12" md="12">
                    <v-card tile color="grey lighten-4">
                        <v-toolbar dense color="primary" class="white--text" height="35px">
                            {{ tr('InitiateProcesses', 'Initiate procedures', 'بدء الإجراءات') }}
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-card tile>
                                        <div class="card-title process-hint">
                                            <v-icon small class="me-1">mdi-information-outline</v-icon>
                                            {{ tr('InitiateProcessesHint', 'Allows the user to start the selected procedure from the Procedures menu. The menu item itself is shown through the menu permissions above; handling tasks depends on the user\'s role in the structure.', 'يسمح للمستخدم ببدء الإجراء المحدد من قائمة الإجراءات. إظهار عنصر القائمة نفسه يتم من صلاحيات القائمة أعلاه، ومعالجة المهام تعتمد على دور المستخدم في الإدارة.') }}
                                        </div>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="4" v-for="item in processPermissions" :key="item.processTypeId">
                                                    <v-checkbox v-model="item.hasAccess" :label="item.name" class="text-start" color="teal" hide-details
                                                                :disabled="processSaving === item.processTypeId"
                                                                @change="updateProcessPermission($event, item)" />
                                                    <v-chip v-if="item.inherited && !item.hasAccess" x-small outlined color="teal" class="mt-1">
                                                        <v-icon x-small class="me-1">mdi-account-group-outline</v-icon>
                                                        {{ tr('InheritedViaRole', 'Granted via role or structure', 'ممنوحة عبر الدور أو الإدارة') }}
                                                    </v-chip>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </CommonDialog>
</template>

<script>
    import CommonDialog from '@/components/controls/CommonDialog'
    import UsersService from '@/services/UsersService.js'
    import LookupsService from '@/services/LookupsService.js'
    import PermissionsService from '@/services/PermissionsService.js'

    export default {
        components: {
            CommonDialog
        },

        props: {
            value: {
                type: Boolean,
                default: false
            },
            userId: {
                type: Number,
            }
        },
        data() {
            return {
                permissions: [],
                userPermissionsList: [],
                permissionLevels: [],
                processPermissions: [],
                processSaving: null
            }
        },

        created() {
            this.loadPermissions()
            this.loadProcessPermissions()
        },

        methods: {

            tr(key, fallbackEn, fallbackAr) {
                if (this.$te(key)) {
                    return this.$t(key)
                }
                return this.$i18n.locale === 'ar' ? fallbackAr : fallbackEn
            },

            loadProcessPermissions() {
                UsersService.listUserProcessPermissions(this.userId).then((res) => {
                    this.processPermissions = res.data || []
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },

            updateProcessPermission(enabled, item) {
                this.processSaving = item.processTypeId
                UsersService.updateProcessPermission(this.userId, item.processTypeId, enabled).then((res) => {
                    if (res.data) {
                        this.$root.$notification(this.$t('UpdateSuccess'), 'success')
                    }
                }).catch(() => {
                    item.hasAccess = !enabled
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.processSaving = null
                })
            },

            updatePermission(event, permissionId, permissionTypeId) {
                UsersService.updatePermission(this.userId, permissionId, permissionTypeId, event).then((res) => {
                    if (res.data) {
                        this.$root.$notification(this.$t('UpdateSuccess'), 'success')
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            setLevel(item, permissionId) {
                this.loading = true
                PermissionsService.setPermissionLevel(item.id, permissionId, this.userId).then((res) => {
                    if (res.data) {
                        this.$root.$notification(this.$t('UpdateSuccess'), 'success')
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            loadPermissions() {
                this.loading = true
                let promises = [
                    UsersService.listUserPermissions(this.userId),
                    LookupsService.listPermissionLevels(),
                ]
                Promise.all(promises).then(([userPermissions, permissionLevels]) => {
                    this.userPermissionsList = userPermissions.data
                    this.permissionLevels = permissionLevels.data
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            }
        },
    }
</script>

<style scoped>
    .process-hint {
        font-size: 0.85rem;
        font-weight: normal;
        color: #5f6b66;
        padding: 8px 16px 0;
    }
</style>